
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../../_constants');

exports.USER_SESSION = _constants.configConstants.LOGIN_TOKEN;
exports.USER_DATA = _constants.configConstants.USER_INFO;
exports.SECURE_PROTOCOL = _constants.configConstants.SECURE_PROTOCOL;